import Api from "@/api/jskyApi";
const END_POINT = `api/${process.env.VUE_APP_FLIGHT_MODE}/flights`;
class FlightsService {
    get_flight_offers(body) {
        return Api.post(`${END_POINT}/result`, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }
    flight_offers_pricing(body) {
        return Api.post(`${END_POINT}/pricing`, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }
    flight_offers_seatmaps(body) {
        return Api.post(`${END_POINT}/seatmaps`, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }
    flight_offers_send_order(body) {
        return Api.post(`${END_POINT}/order`, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }
}
export default new FlightsService();